/**
 * Wishlist Manager for Shopify
 * שמירה ב-localStorage
 */

const WishlistManager = {
  storageKey: 'shopify_wishlist',

  // קבלת כל המוצרים ברשימה
  getItems() {
    const data = localStorage.getItem(this.storageKey);
    return data ? JSON.parse(data) : [];
  },

  // שמירת הרשימה
  saveItems(items) {
    localStorage.setItem(this.storageKey, JSON.stringify(items));
    this.updateAllButtons();
    this.updateCounter();
  },

  // בדיקה אם מוצר ברשימה
  hasItem(productId) {
    return this.getItems().some(item => item.id === productId);
  },

  // הוספת מוצר
  addItem(product) {
    const items = this.getItems();
    if (!this.hasItem(product.id)) {
      items.push({
        id: product.id,
        handle: product.handle,
        title: product.title,
        image: product.image,
        price: product.price,
        comparePrice: product.comparePrice || null,
        url: product.url,
        addedAt: new Date().toISOString()
      });
      this.saveItems(items);
    }
  },

  // הסרת מוצר
  removeItem(productId) {
    console.log('as')
    const items = this.getItems().filter(item => item.id !== productId);
    this.saveItems(items);
  },

  // toggle - הוספה/הסרה
  toggleItem(product) {
    if (this.hasItem(product.id)) {
      this.removeItem(product.id);
      return false;
    } else {
      this.addItem(product);
      return true;
    }
  },

  // עדכון כל כפתורי הלב בדף
  updateAllButtons() {
    document.querySelectorAll('[data-wishlist-btn]').forEach(btn => {
      const productId = btn.dataset.productId;
      const isInWishlist = this.hasItem(productId);
      btn.classList.toggle('is-active', isInWishlist);
      btn.setAttribute('aria-pressed', isInWishlist);
    });
  },

  // עדכון המונה בהדר
  updateCounter() {
    const count = this.getItems().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  },

  // אתחול
  init() {
    this.updateAllButtons();
    this.updateCounter();
    this.bindEvents();
  },

  // הצמדת אירועים
  bindEvents() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-wishlist-btn]');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      const product = {
        id: btn.dataset.productId,
        handle: btn.dataset.productHandle,
        title: btn.dataset.productTitle,
        image: btn.dataset.productImage,
        price: btn.dataset.productPrice,
        comparePrice: btn.dataset.productComparePrice,
        url: btn.dataset.productUrl
      };

      const added = this.toggleItem(product);
      
      // אנימציה קטנה
      btn.classList.add('wishlist-pulse');
      setTimeout(() => btn.classList.remove('wishlist-pulse'), 300);

      // אירוע מותאם אישית
      document.dispatchEvent(new CustomEvent('wishlist:changed', {
        detail: { product, added, count: this.getItems().length }
      }));
    });
  }
};

// אתחול כשהדף נטען
document.addEventListener('DOMContentLoaded', () => WishlistManager.init());